<template>
  <div>
    <PendingCasesEdit></PendingCasesEdit>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
const PendingCasesEdit = defineAsyncComponent(() =>
  import("@/components/pendingCases/EditPendingCase")
);
export default {
  components: {
    PendingCasesEdit,
  },
};
</script>
